'use client';

import { c as _c } from "react/compiler-runtime";
import { ButtonStyle } from '@sola/ark-core/atoms/button-style/button-style.tsx';
import { LinkStyle } from '@sola/ark-core/atoms/link-style/link-style.tsx';
import { Link } from '@sola/ark-core/atoms/link/link.tsx';
import { Link as LinkSchema } from '@sola/schema/lib/schema.ts';
interface LightboxButtonsProps {
  primaryCTA?: LinkSchema;
  secondaryCTA?: LinkSchema;
  tertiaryCTA?: LinkSchema;
  buttonSize?: 'sm' | 'md' | 'lg' | 'xl';
  inline?: boolean;
}
export const LightboxButtons: React.FC<LightboxButtonsProps> = t0 => {
  const $ = _c(15);
  const {
    primaryCTA,
    secondaryCTA,
    tertiaryCTA,
    buttonSize: t1
  } = t0;
  const buttonSize = t1 === undefined ? "md" : t1;
  let t2;
  if ($[0] !== buttonSize) {
    t2 = (cta, variant, className) => {
      if (!cta) {
        return null;
      }
      if (variant === "tertiary") {
        return <LinkStyle size={buttonSize} iconAfter="arrow-right" noPadding={true} noUnderline={true} inline={true}><Link download={cta.isDownload} href={cta.link} target={cta.target} className={className}>{cta.title}</Link></LinkStyle>;
      }
      return <ButtonStyle variant={variant} size={buttonSize}><Link download={cta.isDownload} href={cta.link} target={cta.target} className={className}>{cta.title}</Link></ButtonStyle>;
    };
    $[0] = buttonSize;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const renderButton = t2;
  let t3;
  if ($[2] !== primaryCTA || $[3] !== renderButton) {
    t3 = primaryCTA && renderButton(primaryCTA, "primary");
    $[2] = primaryCTA;
    $[3] = renderButton;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== renderButton || $[6] !== secondaryCTA) {
    t4 = secondaryCTA && renderButton(secondaryCTA, "secondary");
    $[5] = renderButton;
    $[6] = secondaryCTA;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== renderButton || $[9] !== tertiaryCTA) {
    t5 = tertiaryCTA && renderButton(tertiaryCTA, "tertiary", "ml-snug-lg");
    $[8] = renderButton;
    $[9] = tertiaryCTA;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t3 || $[12] !== t4 || $[13] !== t5) {
    t6 = <div className="flex items-center justify-center gap-snug-lg">{t3}{t4}{t5}</div>;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
};